import axios from 'axios';
import { TextAndImage, FrontPage } from './models';

const service = axios.create({
	baseURL: '/api/ajax/B2CApi/'
});

export default {
	/**
	 * Get the B2C cover image (forsidebilde)
	 * @returns {*} Object with the source uri, and the alternative text for the image. Null if not found.
	 */
	async GetCoverImage() {
		const result = await axios.get('/api/ajax/B2CApi/GetCoverImage');
		switch (Object(result.data).ResponseCode) {
			case 200:
				return result.data.EzContent;

			default:
				return null;
		}
	},

	/**
	 * Get the content for the text and image module.
	 * @returns {*} Object with texts and images. Null if not found.
	 * @deprecated Use `GetFrontPageContent` instead.
	 */
	async GetTextAndImage() {
		const result = await axios.get('/api/ajax/B2CApi/GetTextAndImage');
		switch (Object(result.data).ResponseCode) {
			case 200:
				return new TextAndImage(result.data.EzContent);

			default:
				return null;
		}
	},

	/**
	 * Get the content for the text and image module.
	 * @returns {*} Object with texts and images. Null if not found.
	 */
	async GetFrontPageContent() {
		const result = await axios.get('/api/ajax/B2CApi/GetTextAndImage');
		switch (Object(result.data).ResponseCode) {
			case 200:
				return new FrontPage(result.data.EzContent);

			default:
				return null;
		}
	}
};
